import ArtifactDisplay from "./Cosmetic/ArtifactDisplay";
import CapeDisplay from "./Cosmetic/CapeDisplay";
import ProjectileDisplay from "./Cosmetic/ProjectileDisplay";
import KillphraseDisplay from "./Cosmetic/KillphraseDisplay";
import MountDisplay from "./Cosmetic/MountDisplay";
import NoPage from "../utils/NoPage";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Cosmetic() {
  const { type } = useParams();

  const typeMap = {
    artifact: "Artifacts",
    cape: "Capes",
    projectile: "Projectiles",
    killphrase: "Killphrases",
    mount: "Mounts",
  };

  const readableType = typeMap[type];

  if (!readableType) {
    return <NoPage />;
  }

  const description = `Browse Zeqa's ${readableType}s here.`;

  return (
    <div>
      <div className="page_container">
        <Helmet>
          <title>{readableType} | Cosmetics</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={`${readableType} | Cosmetics`} />
          <meta property="og:description" content={description} />
          <meta property="og:type" content="website" />
          <meta
            property="twitter:title"
            content={`${readableType} | Cosmetics`}
          />
          <meta property="twitter:description" content={description} />
        </Helmet>

        {type === "artifact" && <ArtifactDisplay />}
        {type === "cape" && <CapeDisplay />}
        {type === "projectile" && <ProjectileDisplay />}
        {type === "killphrase" && <KillphraseDisplay />}
        {type === "mount" && <MountDisplay />}
      </div>{" "}
      <br></br>{" "}
    </div>
  );
}
